import _ from "lodash"
import PropTypes from "prop-types"

export default function TypeNumberOutcomes({ value, description }) {
  let newValue = ""

  newValue =
    "<span class='outcomes-description'><strong>" +
    description +
    "</strong></span><span class='outcomes-value'>" +
    value +
    "</span>"

  if (!_.isNull(value)) {
    return (
      <div
        className="outcomes-values"
        dangerouslySetInnerHTML={{
          __html: newValue,
        }}
      />
    )
  } else {
    return null
  }
}

TypeNumberOutcomes.propTypes = {
  value: PropTypes.string,
  description: PropTypes.string,
}
